import { useMemo, useState } from 'react';
import type { InventoryInspectionOutput, ReactSimpleComponentProps } from '@/custom-types';
import { InventoryFormModalContext, InventoryFormModalContextProps, InventoryFormMode } from './InventoryFormModalContext';

export const InventoryFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<InventoryFormMode>('create');
  const [propertyId, setPropertyId] = useState<string | null>(null);
  const [inventory, setInventory] = useState<InventoryInspectionOutput | null>(null);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const actions = useMemo<
    Omit<InventoryFormModalContextProps, 'isOpen' | 'mode' | 'propertyId' | 'inventory' | 'isReadOnly'>
  >(
    () => ({
      closeModal: () => {
        setIsOpen(false);
        setInventory(null);
        setIsReadOnly(false);
      },
      openCreateModal: (propId: string) => {
        setMode('create');
        setPropertyId(propId);
        setInventory(null);
        setIsReadOnly(false);
        setIsOpen(true);
      },
      openEditModal: (propId: string, inv: InventoryInspectionOutput) => {
        setMode('edit');
        setPropertyId(propId);
        setInventory(inv);
        setIsReadOnly(false);
        setIsOpen(true);
      },
      openDetailsModal: (propId: string, inv: InventoryInspectionOutput) => {
        setMode('edit');
        setPropertyId(propId);
        setInventory(inv);
        setIsReadOnly(true);
        setIsOpen(true);
      },
    }),
    [],
  );

  return (
    <InventoryFormModalContext.Provider
      value={{
        ...actions,
        isOpen,
        mode,
        propertyId,
        inventory,
        isReadOnly,
      }}
    >
      {children}
    </InventoryFormModalContext.Provider>
  );
};

